export interface TreatmentReview {
    id: number;
    hasRead: boolean;
    dateAdded: string | Date;
    dateUpdated?: string | Date | null;
    treatmentId: string;
    status: TreatmentReviewStatus;
    reviewerId: string;
    rejectReason?: string | null;
}

export enum TreatmentReviewStatus {
    none = 0,
    accepted = 1,
    rejected = 2,
    ignored = 3,
    requested = 4,
}
